<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-12">
          <h6 class="h2 text-white d-inline-block mb-0">Crear Productor</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div v-if="!saved" class="row justify-content-center">
        <producer-form :server-errors="serverErrors" @save="saveProducer"></producer-form>
      </div>

      <div v-if="saved" class="row justify-content-center">
        <div class="col-5">
          <contact-form ref="contactForm" :title="contactFormTitle" @save="saveContact">
            <template slot="extra-actions">
              <router-link :to="{ name: 'ProducersList' }" class="btn base-button btn-neutral">Omitir</router-link>
            </template>
          </contact-form>
        </div>

        <div class="col-5">
          <contacts-list :collapsed="false" :entity-id="producerId" entity="producers"></contacts-list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import ProducerForm from './Forms/ProducerForm';
import ContactForm from '../Contacts/Forms/ContactForm';
import ContactsList from '../Contacts/List/ContactsList';
import ContactEventBus from '@/events/buses/contacts.event';
import swal from 'sweetalert2';

export default {
  name: 'ProducersCreate',
  components: {
    RouteBreadCrumb,
    ProducerForm,
    ContactForm,
    ContactsList,
  },

  data() {
    return {
      saved: false,
      serverErrors: [],
      producerId: null,
      contactFormTitle: null,
    };
  },

  created() {
    ContactEventBus.$on('contacts-list-loaded', this.showCreatedMessage);
  },

  beforeDestroy() {
    ContactEventBus.$off('contacts-list-loaded', this.showCreatedMessage);
  },

  methods: {
    saveContact(contact) {
      this.$refs.contactForm.create(contact, this.producerId, 'producers');
    },

    saveProducer(producer) {
      this.$services
        .resource('producers')
        .create(producer)
        .then((res) => res.data.data)
        .then((data) => {
          this.saved = true;
          this.producerId = +data.id;
          this.contactFormTitle = `Agregar contactos para ${data.businessName}`;
        })
        .catch((errors) => {
          this.serverErrors = errors;
        });
    },

    showCreatedMessage() {
      swal({
        title: 'Listo!',
        text: 'El productor fue creado.',
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-success',
        type: 'success',
      });
    },
  },
};
</script>
